var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropertyManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 355,
    viewBox: "0 0 300 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5873_1278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6771 202.51L24.0215 216.834L48.7764 202.748",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.609 308.046L148.49 348.119L188.047 325.132",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0004 113.006L1.13281 92.8807L40.6891 69.874",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.578 116.424C105.796 158.404 135.021 210.596 171.001 232.113",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.604 256.709C98.683 238.669 77.6631 204.437 71.6234 170.345C68.7029 152.067 70.332 128.265 88.2525 118.192",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.604 256.708C141.815 264.357 157.749 268.35 170.921 260.324",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.404 238.371C180.795 237.059 175.947 235.013 170.98 232.112",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.531 280.112C257.942 282.556 273.617 309.695 275.485 312.933L233.127 337.549L208.531 294.953L239.703 276.834",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.776 34.5296L114.756 34.5098",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.935 29.662L95.3651 0.993164L53.0273 25.6091L77.6035 68.2051L109.074 49.9269",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5179 41.8607C41.5047 31.9468 78.5378 10.4899 95.3656 0.993164C78.359 10.9269 41.3457 32.3839 24.498 41.8607H24.5179Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.642 266.424C219.139 278.046 214.649 287.642 208.51 294.954L239.682 276.834",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26 42.8936H129.24",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.074 49.9268L77.6035 68.2248C87.0605 66.6552 97.6697 67.6486 109.014 71.3837",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.869 176.702L251.227 152.086C257.306 166.45 261.717 181.192 264.141 195.636L221.783 220.251C219.359 205.808 214.949 191.066 208.869 176.702Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.207 94.569L191.565 69.9531C202.909 79.3107 213.479 90.5558 222.896 103.013L180.538 127.629C171.121 115.172 160.532 103.927 149.207 94.569Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.649 240.397L299.006 215.781L298.867 261.953L256.51 286.569L256.649 240.397Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.781 220.252L264.139 195.636L299.006 215.781L256.649 240.397L221.781 220.252Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.133 31.2907L151.49 6.6748L191.682 29.8801L149.325 54.496L109.133 31.2907Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.326 54.4968L191.684 29.8809L191.565 69.9537L149.207 94.5696L149.326 54.4968Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.537 127.629C196.093 118.55 232.332 97.5099 247.65 88.9072C232.093 97.9867 195.855 119.026 180.537 127.629Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.511 286.57L221.643 266.444C219.16 278.066 214.67 287.642 208.531 294.974L233.127 337.55L204.617 353.821L180.021 311.225C170.564 312.775 159.954 311.782 148.61 308.046L148.491 348.119L108.299 324.914L108.418 284.841C97.0935 275.484 86.5239 264.239 77.0869 251.801L52.3319 265.907L24.0206 216.835L48.7756 202.748C42.6961 188.384 38.2657 173.623 35.8617 159.179L0.994141 139.053L1.13321 92.8809L36.0008 113.007C38.4643 101.384 42.9743 91.7882 49.1133 84.4769L24.5173 41.861L53.0273 25.6094L77.6233 68.2054C87.0802 66.6359 97.6895 67.6292 109.034 71.3643L109.153 31.2915L149.345 54.4968L149.226 94.5696C160.57 103.927 171.14 115.172 180.557 127.629L205.312 113.523L233.643 162.596L208.888 176.702C214.968 191.066 219.378 205.808 221.802 220.252L256.67 240.378L256.531 286.55L256.511 286.57ZM128.603 256.709C160.829 275.305 187.014 260.384 187.113 223.371C187.213 186.338 161.186 141.278 128.981 122.662C96.7756 104.066 70.5703 118.987 70.471 156.02C70.3716 193.033 96.418 238.113 128.603 256.709Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.293 113.523L247.651 88.9072L275.982 137.98L233.624 162.596L205.293 113.523Z",
    stroke: "#0000FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5873_1278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 354.815,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyManagement);
export default __webpack_public_path__ + "static/media/property_management.eb8e5301740003595be9cd1b33584cd5.svg";
export { ForwardRef as ReactComponent };